'use client';

import { useMediaMatchers } from '@/lib/media_utils';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { SearchBar } from './SearchBar';

export const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isBackgroundLoaded, setIsBackgroundLoaded] = useState(false);
  const { isMobile } = useMediaMatchers();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1000);

    const backgroundTimer = setTimeout(() => {
      setIsBackgroundLoaded(true);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearTimeout(backgroundTimer);
    };
  }, []);

  return (
    <section className="relative min-h-[600px] sm:min-h-[700px] md:min-h-[900px] flex items-center justify-center w-full flex-col overflow-hidden">
      <div className="absolute inset-0 z-0">
        <Image
          src="/hero.jpg"
          alt="Luxury vacation scene with person on yellow sofa"
          fill
          className={cn(
            'object-cover transition-transform duration-700',
            isBackgroundLoaded ? 'scale-100' : 'scale-110'
          )}
          priority
          quality={isMobile ? 75 : 90}
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 80vw, (max-width: 1536px) 70vw, 1200px"
        />
        <div
          className={cn(
            'absolute inset-0 bg-gradient-to-b from-black/30 via-black/30 to-black/30 z-10 transition-opacity duration-700 opacity-10'
          )}
        />
      </div>

      <div
        className={cn(
          'relative z-20 px-4 text-center text-white transition-all duration-1000 delay-500 w-full max-w-6xl mx-auto mt-28 md:mt-0 font-extrabold font-milligram uppercase',
          isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        )}
      >
        <h1 className="text-2xl md:text-6xl lg:text-7xl xl:text-8xl drop-shadow-2xl text-shadow-lg">
          YOUR VACATION DESERVES TO BE ICONIC
        </h1>
        <p className="md:block hidden text-2xl drop-shadow-2xl text-shadow-lg">
          Extraordinary homes. Trusted hosts. Peace of mind, every time.
        </p>

        <div className="w-full mt-10">
          <SearchBar isHero={true} />
        </div>
      </div>
    </section>
  );
};
